import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const reinviteExecutorApi = (wireId: string, executorId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/executors/${executorId}/reinvite/`;

  return authApiService.POST(uri, {});
};
